import { PosSessionsFacade } from '@adminStore/pos-sessions';
import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, of, take } from 'rxjs';

export const posSessionGuard: CanActivateFn = () => {
  const posSessionsFacade = inject(PosSessionsFacade);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return of(true);
  }

  posSessionsFacade.loadCurrentSession();

  return combineLatest([
    posSessionsFacade.currentSession$,
    posSessionsFacade.currentSessionLoading$,
  ]).pipe(
    filter(([ , loading ]) => !loading),
    map(([ session ]) => {
      if (session) {
        return true;
      }

      router.navigate([ '/pos/open-session' ], {
        state: { skipCurrentSessionLoad: true },
      });
      return false;
    }),
    take(1),
  );
};
